import { createTheme } from '@mui/material/styles';
import { nlNL } from '@mui/material/locale';

/**
 * Het thema van het CRM: rustige kleuren, Inter als lettertype en compacte formulieren.
 */
export const thema = createTheme(
  {
    palette: {
      primary: { main: '#0f4c81' },
      secondary: { main: '#7c3aed' },
      background: { default: '#f4f6f9' },
    },
    shape: { borderRadius: 8 },
    typography: {
      fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
      h4: { fontSize: '1.6rem', fontWeight: 600 },
      h5: { fontSize: '1.25rem', fontWeight: 600 },
      h6: { fontSize: '1.05rem', fontWeight: 600 },
    },
    components: {
      MuiCard: { defaultProps: { variant: 'outlined' } },
      MuiPaper: { styleOverrides: { root: { backgroundImage: 'none' } } },
      MuiButton: { defaultProps: { disableElevation: true }, styleOverrides: { root: { textTransform: 'none' } } },
      MuiTableCell: { styleOverrides: { head: { fontWeight: 600 } } },
      MuiChip: { styleOverrides: { root: { fontWeight: 500 } } },
    },
  },
  nlNL,
);
